export default "/images/9989fa37bbf8fe062f5eae2f97a338e1.avif";